import React, { useState } from 'react';
import { useGetInfoQuery, useLazyGetPermissionsQuery } from '../features/auth/authApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectCompanyGuid, setCompany, setPermissions } from '../features/auth/authSlice';
import { apiSlice } from '../app/api/apiSlice';
import Loading from './commons/Loading';
import { useLazyGetMainSettingsQuery } from 'features/core/settings/api/mainSettingsApiSlice';
import { setSessionExpiry } from 'features/auth/sessionSlice';
import { useNavigate } from 'react-router-dom';

const CompanySwitch = ({ onChange }) => {


    const { data: infoData, isSuccess, isLoading: isLoadingInfo } = useGetInfoQuery()
    const [getPermissions, { isLoading: permissionsIsLoading }] = useLazyGetPermissionsQuery()
    // const [getSettings, { isLoading: settingsIsLoading }] = useLazyGetMainSettingsQuery()
    const currentCompanyGuid = useSelector(selectCompanyGuid)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleSelectChange = async (event) => {
        const selectedId = event.target.value;
        const selectedCompany = options.find(option => option.guid === selectedId);
        dispatch(setCompany(selectedCompany))
        
        // Retriving Permissions
        const permissions = await getPermissions().unwrap()
        dispatch(setPermissions(permissions))

        // Dopo l'autenticazione, imposta la durata della sessione
        // const settings = await getSettings().unwrap()
        // const sessionDuration = settings.session_duration * 60; // Durata in secondi
        // const expiryTime = Date.now() + sessionDuration * 1000;
        // dispatch(setSessionExpiry(expiryTime)); // Aggiorna Redux con l'orario di scadenza

        navigate('/dashboard/home')
    
        dispatch(apiSlice.util.resetApiState());
        
    };

    let selectedOption
    let options

    if(isLoadingInfo | permissionsIsLoading) return <Loading/>

    if (isSuccess) {
        options = infoData.employments.map(e => e.company)
        selectedOption = options.find(company => company.guid == currentCompanyGuid).guid
    } 

    if (options.length == 1) return
    return (
        <select value={selectedOption} onChange={handleSelectChange}>
            {options.map(option => (
                <option key={option.guid} value={option.guid} >
                    {option.name}
                </option>
            ))}
        </select>
    );
};

export default CompanySwitch;


